<template>
    <div class="flex-1 d-flex flex-column h-100">
        <div class="flex-1 d-flex flex-column overflow-auto p-4">
           <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-md-4 p-0">
                    <label>{{ $t("res_Label_Structures") }} *</label>
                    <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                    :showInternalStructures="true" :showExternalStructures="false"
                                    :excludeSelf="true" :isMultiple="false" :disabled="structureData.structureDisable"
                                    :selectedStructureUser="structureData.structure"
                                    @structureUserSelectChanged="selectStructureChanged">
                    </StructureUserSelector>
                </div>
                <div class="col-md-4 p-0">
                    <label>{{ $t("res_Label_Role") }}</label>
                    <multi-select class="light-bg add-arrow" v-model="structureData.contactRole" label="name" track-by="id" open-direction="bottom" :options="contactRoles" :searchable="true" :loading="loading" 
                        :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="false" :placeholder="$t('res_Label_Select')">
                    </multi-select>
                </div>
                <div class="col-md-4 flex-1 p-0">
                    <label>{{ $t("res_Label_PrivacyLevel") }} *</label>
                    <multi-select class="light-bg add-arrow" v-model="structureData.privacyLevel" label="name" track-by="id" open-direction="bottom" :options="privacies" :searchable="true" :loading="loading" 
                        :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="false" :placeholder="$t('res_Label_Select')">
                    </multi-select>
                </div>
            </div>
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-md-4 p-0">
                    <label>{{$t("res_Label_Profession")}} *</label>
                    <textarea v-model="structureData.profession" label="" class="customTextarea" solo style="min-height: 90px"></textarea>
                </div>
                <div class="col-md-4 p-0">
                    <label>{{$t("res_Label_ProfessionAr")}} *</label> 
                    <textarea v-model="structureData.professionAr" label="" class="customTextarea" solo style="min-height: 90px"></textarea>
                </div>
            </div>
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-2 flex-1 p-0">
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.isStructureReceiver" :label="$t('res_CheckBox_IsStructureReciever')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.isDesignatedPerson" :label="$t('res_Label_IsDesignatedPerson')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.isDefaultDesignatedPerson" :label="$t('res_Label_IsDefaultDesignatedPerson')"></v-checkbox>
                </div> 
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.canSearchInDepartment" @change="SetSubDep()" :label="$t('res_Label_CanSearchInDep')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.canSearchInSubDepartment" :disabled="!structureData.canSearchInDepartment" :label="$t('res_Label_CanSearchInSubDep')"></v-checkbox>
                </div>
            </div>
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.allowSignSpecial"  :label="$t('res_Label_AllowSignSpecial')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.dontShowInTransfer" :label="$t('res_Label_DontShowInTransfer')"></v-checkbox>
                </div>
                <div class="col-2 flex-1 p-0" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.editSigned"  :label="$t('res_Label_EditSigned')"></v-checkbox>
                </div>
                <div class="col-2 flex-1" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.allowESignature" :label="$t('res_Lable_CanSignWithESign')"></v-checkbox>
                </div>
                <div class="col-2 flex-1" >
                    <v-label></v-label>
                    <v-checkbox class="mt-0 mb-2" v-model="structureData.allowUAEPASSSignature" :label="$t('res_Lable_CanSignWithUAEPASS')"></v-checkbox>
                </div>
            </div>     
            
            <div class="mt-2">
               <v-btn class="light-blue" style="min-width: 100px !important" @click="resetStructureUser()">{{ $t("res_ButtonText_Reset") }}</v-btn>
                <v-btn class="primary mx-2" style="min-width: 100px !important"  @click="addStructureUser()" v-if="!showUpdateStructureUserBtn">{{ $t("res_ButtonText_Add") }}</v-btn>
                <v-btn class="primary" style="min-width: 100px !important" v-if="showUpdateStructureUserBtn" @click="updateStructureUser()">{{ $t("res_ButtonText_Update") }}</v-btn>
            </div>
            <v-dialog v-model="autoForwardDialog" max-width="50%">
                <div>
                    <v-toolbar class="shadow-none" content-class="h-auto">      
                        <div class="d-flex align-items-center">
                            <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_AutoForwardRules")}}</v-toolbar-title>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="closeAutoForwardDialog()">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                </div>
                <div class="dialog-body bg-white" style="width: 100%; height: 100%;" >
                    <AutoForward :fromStructerId="fromId" :UserId="userId" />
                </div>
            </v-dialog>    
            <hr>
            <v-data-table  class="d-flex flex-column flex-1 order-table" :headers="structureHeaders" 
            :items="structureData.structureDataArray" :items-per-page="10" :class="{'no-data': structureData.structureDataArray.length == 0}" >
                <template v-slot:item="row" item-key="structure">
                    <tr>
                        <td style="display: none">{{ row.item.id }}</td>
                        <td>{{ row.item.structure }}</td>
                        <td>{{ row.item.privacyLevel }}</td>
                        <td>{{ row.item.contactRole }}</td>
                        <td>{{ row.item.profession }}</td>
                        <td>{{ row.item.ProfessionAr }}</td>
                        <td>{{ yesNo(row.item.isStructureReceiver) }}</td>
                        <td>{{ yesNo(row.item.isDesignatedPerson) }}</td>
                        <td>{{ yesNo(row.item.IsDefaultStructure) }}</td>
                        <td>{{ yesNo(row.item.canSearchInDepartment) }}</td>
                        <td>{{ yesNo(row.item.canSearchInSubDepartment) }}</td>
                        <td>{{ yesNo(row.item.allowSignSpecial) }}</td>
                        <td>{{ yesNo(row.item.dontShowInTransfer) }}</td>
                        <td>{{ yesNo(row.item.editSigned) }}</td>
                        <td>{{ yesNo(row.item.allowESignature) }}</td>
                        <td>{{ yesNo(row.item.allowUAEPASSSignature) }}</td>
                        <td>{{ yesNo(row.item.active) }}</td>
                        <td class="text-start">
                            <div class="onhover-display">
                                <div class="custom-icon-wrapper" v-if="!row.item.IsDefaultStructure && row.item.active" >
                                    <v-icon @click="makeDefaultStructure(row.item.id)">custom-icon primary-bg plus1-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper">
                                    <v-icon @click="showEditStructureUserData(row.item)" >custom-icon white-bg edit-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" >
                                    <v-icon v-tooltip.hover="$t('res_Hover_ActiveOrDeActive')" @click="StructureUserActivationStatusChange(row.item.id, row.item.active)">{{ row.item.active ? 'mdi-account-off' : 'mdi-account-check' }}</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" v-if="hasPermission('AutoForward')" >
                                    <v-icon title="Forward" @click="openAutoForwardDialog(row.item.id)" >mdi-forward</v-icon>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-data>
                <v-row class="p-5">
                    <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                    <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                </v-row>
            </template>
            </v-data-table>
            </div>
        <v-card-actions class="gap-2 sticky-actions">
            <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="close()">{{$t("res_ButtonText_Cancel")}}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants'
    import MultiSelect from 'vue-multiselect'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
	import * as utils from '@/assets/js/common.js'
    import AutoForward from './AutoForward.vue';
    
    export default {
        name: 'ManageStructures',
        components: { MultiSelect, AutoForward, StructureUserSelector},
        data: function () 
        {
            return {
                showUpdateStructureUserBtn: false,
                managerUserStructureDialog: false,
                loading: false,
                autoForwardDialog:false,
                structures: [],
                constants:constants,
                fromId:null,
                privacies: [],
                contactRoles: [],
                structureData: {
                    structure: null,
                    contactRole: null,
                    privacyLevel: null,
                    profession: '',
                    professionAr: '',
                    isStructureReceiver: false,
                    isDesignatedPerson: false,
                    isDefaultDesignatedPerson: false, 
                    editSigned:false,
                    structureDataArray: [],
                    structureDisable: false,
                    canSearchInDepartment: false,
                    canSearchInSubDepartment: false,
                    allowSignSpecial: false,
                    dontShowInTransfer: false,
                    allowESignature: false,
                    allowUAEPASSSignature: false
                },
                structureHeaders: [
                    { text: 'Id', value: 'id', sortable: false, align: ' d-none'},
                    { text: this.$t("res_GridHeaders_StructureName"), value: 'structure', sortable: false },
                    { text: this.$t("res_GridHeaders_PrivacyLevel"), value: 'privacyLevel', sortable: false },
                    { text: this.$t("res_GridHeaders_ContactRole"), value: 'contactRole', sortable: false },
                    { text: this.$t("res_GridHeaders_Profession"), value: 'profession', sortable: false },
                    { text: this.$t("res_GridHeaders_ProfessionAr"), value: 'ProfessionAr', sortable: false },
                    { text: this.$t("res_GridHeaders_StructureReceiver"), value: 'isStructureReceiver', sortable: false },
                    { text: this.$t("res_GridHeaders_DesignatedPerson"), value: 'isDesignatedPerson', sortable: false },
                    { text: this.$t("res_GridHeaders_IsDefaultStructure"), value: 'IsDefaultStructure', sortable: false}, 
                    { text: this.$t("res_Label_CanSearchInDep"), value: 'canSearchInDepartment', sortable: false},
                    { text: this.$t("res_Label_CanSearchInSubDep"), value: 'canSearchInSubDepartment', sortable: false},
                    { text: this.$t("res_Label_AllowSignSpecial"), value: 'allowSignSpecial', sortable: false},
                    { text: this.$t("res_Label_DontShowInTransfer"), value: 'dontShowInTransfer', sortable: false},
                    { text: this.$t("res_Label_EditSigned"), value: 'editSigned', sortable: false},
                    { text: this.$t("res_Lable_CanSignWithESign"), value: 'allowESignature', sortable: false},
                    { text: this.$t("res_Lable_CanSignWithUAEPASS"), value: 'allowUAEPASSSignature', sortable: false},
                    { text: this.$t("res_GridHeaders_Active"), value: 'active', sortable: false},
                    { text: '', value: '', sortable: false, width: '130px'},
                ],
            };
        },
        props: {
            userId: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
        },
        methods:
        {
            yesNo(value)
            {
                return value == true ? this.$t("res_ButtonText_Yes") : this.$t("res_ButtonText_No");
            },
            initForm()
            {
                this.contactRoles=[];
                this.contactRoles.push({ id: 0 , name: '---' , nameAr: '---' }); 
                if(constants.contactRoles != null && constants.contactRoles.length > 0)
                {
                    constants.contactRoles.forEach(role => {
                        this.contactRoles.push(role);
                    });
                }
                this.privacies = constants.privacies
                this.fetchNewStructure();
            },
            selectStructureChanged(item) {
                this.structureData.structure = item
            },
            asyncFindAllDepartments(query) 
            {
                this.structures = [];
                var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=false&search=';

                this.loading = true
                window.showLoading();
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => 
                    {
                        if (res.data != null)
                        {
                            this.structures = res.data
                            this.loading = false
                        }
                    })
                    .catch(() => this.loading = false)
                    .finally(()=> window.hideLoading())
            },
            fetchNewStructure()
            {
                this.structureData.structureDataArray = [];
                window.showLoading();
                axios.post(constants.baseApiUrl + 'StructureUser/GetUserStructures?userID=' + this.userId, { headers: constants.headers })
                    .then(response => 
                    {
                        if (response.data != null)
                        {
                            response.data.forEach((element) =>
                            {
                                let privacyLevel = "";
                                let contactRole = "";
                                
                                if (element.privacyLevel)
                                    privacyLevel = this.privacies.find(x => x.id == element.privacyLevel)?.name;

                                if (element.contactRoleId)
                                    contactRole = this.contactRoles.find(x => x.id == element.contactRoleId)?.name;

                                var structureDataBody = {
                                    id: element.structureId,
                                    structure: element.structureName,
                                    privacyLevel: privacyLevel,
                                    contactRole: contactRole,
                                    profession: element.profession,
                                    ProfessionAr: element.professionAr,
                                    isStructureReceiver: element.isStructureReceiver != null ? element.isStructureReceiver : false,
                                    isDesignatedPerson: element.isDesignatedPerson != null ? element.isDesignatedPerson : false,
                                    isDefaultDesignatedPerson: element.isDefaultDesignatedPerson != null ? element.isDefaultDesignatedPerson : false,
                                    IsDefaultStructure: element.isDefaultStructure, 
                                    allowSignSpecial: element.allowSignSpecial != null ? element.allowSignSpecial : false,
                                    dontShowInTransfer: element.dontShowInTransfer != null ? element.dontShowInTransfer : false,
                                    editSigned: element.editSigned != null ? element.editSigned : false,
                                    canSearchInDepartment: element.canSearchInDepartment,
                                    canSearchInSubDepartment: element.canSearchInSubDepartment,
                                    allowESignature: element.allowESignature,
                                    allowUAEPASSSignature: element.allowUAEPASSSignature,
                                    active: element.active,
                                }

                                this.structureData.structureDataArray.push(structureDataBody);
                            });

                            this.managerUserStructureDialog = true;
                        }
                    }).catch(err => console.warn(err))
                    .finally(()=> window.hideLoading())
            },
            showEditStructureUserData(item)
            {
                this.showUpdateStructureUserBtn = true;
                this.structureData.structure = {name: item.structure, id: item.id};
                this.structureData.structureDisable = true;
                this.structureData.contactRole = this.contactRoles.find(x => x.name == item.contactRole);
                this.structureData.privacyLevel =  this.privacies.find(x => x.name == item.privacyLevel);
                this.structureData.profession = item.profession;
                this.structureData.professionAr = item.ProfessionAr;
                this.structureData.isStructureReceiver = item.isStructureReceiver;
                this.structureData.isDesignatedPerson = item.isDesignatedPerson;
                this.structureData.isDefaultDesignatedPerson = item.isDefaultDesignatedPerson; 
                this.structureData.allowSignSpecial = item.allowSignSpecial;
                this.structureData.dontShowInTransfer = item.dontShowInTransfer;
                this.structureData.editSigned = item.editSigned;
                this.structureData.canSearchInDepartment = item.canSearchInDepartment;
                this.structureData.canSearchInSubDepartment = item.canSearchInSubDepartment;
                this.structureData.allowESignature = item.allowESignature;
                this.structureData.allowUAEPASSSignature = item.allowUAEPASSSignature;
            },
            makeDefaultStructure(structureId)
            {
                window.showLoading();
                axios.post(constants.baseApiUrl + 'User/UpdateDefaultUser?userId=' + this.userId + "&structureId=" + structureId, { headers: constants.headers })
                    .then(response =>
                    {
                        if (response.data != null && response.data > 0)
                        {
                            window.showAlert(this.$t("res_Msgs_SetDefaultStructure"), 'success');
                            this.resetStructureUser();
                            this.fetchNewStructure();
                        }
                        else
                        {
                            window.showAlert(this.$t("res_Msgs_CannotSetInactiveStructureAsDefault"), 'warning');
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(()=> window.hideLoading())
            },
            openAutoForwardDialog(id){
                this.fromId=id;
                this.autoForwardDialog=true;
             },
             closeAutoForwardDialog(){
                this.autoForwardDialog=false;
             },
            StructureUserActivationStatusChange(structureId,isActive)
            {
                window.showInformation(	
                    this.$t("res_Msgs_Confirmation"),	
                    isActive ? this.$t('res_Msgs_UserDeActiveConfirmation') : this.$t('res_Msgs_UserActiveConfirmation'),	
                    () =>	
                    {	
                        window.showLoading();
                        axios.get(constants.baseApiUrl + 'StructureUser/ToggleStructureUserActivationStatus?UserId=' + this.userId + '&StructureId=' 
                            + structureId, { headers: constants.headers })
                            .then(response =>
                            {
                                if (response.data != null && response.data != "success")
                                {
                                    window.showAlert(this.$t(response.data), 'warning');
                                }
                                else
                                {
                                    this.fetchNewStructure();
                                }
                            })
                        .catch(err => console.warn(err))
                        .finally(()=> window.hideLoading())
                },	
                () => { });	
            },
            SetSubDep()
            {
                if (this.structureData.canSearchInDepartment == false)
                    this.structureData.canSearchInSubDepartment = false
            },
            resetStructureUser()
            {
                this.structureData.structure = null
                this.structureData.contactRole =  null
                this.structureData.privacyLevel =  null
                this.structureData.profession = ''
                this.structureData.professionAr = ''
                this.structureData.isStructureReceiver = false
                this.structureData.isDesignatedPerson = false
                this.structureData.isDefaultDesignatedPerson = false
                this.showUpdateStructureUserBtn = false
                this.structureData.structureDisable = false 
                this.structureData.allowSignSpecial = false
                this.structureData.dontShowInTransfer = false
                this.structureData.editSigned = false  
                this.structureData.canSearchInDepartment = false 
                this.structureData.canSearchInSubDepartment = false
                this.structureData.allowESignature = false
                this.structureData.allowUAEPASSSignature = false

            },
            addStructureUser()
            {
                if (this.structureData.structure == null || this.structureData.privacyLevel == null)
                {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                    return
                }

                var addStructureDataBody = {
                    UserId:  this.userId,
                    StructureId: this.structureData.structure?.id ?? null,
                    Profession: this.structureData.profession,
                    ProfessionAr: this.structureData.professionAr,
                    IsStructureReceiver: this.structureData.isStructureReceiver != null ? this.structureData.isStructureReceiver : false,
                    IsDesignatedPerson: this.structureData.isDesignatedPerson != null ? this.structureData.isDesignatedPerson : false,
                    IsDefaultDesignatedPerson: this.structureData.isDefaultDesignatedPerson != null ? this.structureData.isDefaultDesignatedPerson : false,
                    PrivacyLevel: this.structureData.privacyLevel.id,
                    ContactRoleId: this.structureData.contactRole == null || this.structureData.contactRole.id == 0 ? null : this.structureData.contactRole.id, 
                    AllowSignSpecial: this.structureData.allowSignSpecial != null ? this.structureData.allowSignSpecial :false,
                    dontShowInTransfer: this.structureData.dontShowInTransfer != null ? this.structureData.dontShowInTransfer :false,
                    EditSigned: this.structureData.editSigned != null ? this.structureData.editSigned :false,
                    CanSearchInDepartment: this.structureData.canSearchInDepartment,
                    CanSearchInSubDepartment: this.structureData.canSearchInSubDepartment,
                    AllowESignature: this.structureData.allowESignature != null ? this.structureData.allowESignature : false,
                    AllowUAEPASSSignature: this.structureData.allowUAEPASSSignature != null ? this.structureData.allowUAEPASSSignature : false,

                }

                window.showLoading();
                axios.post(constants.baseApiUrl + 'StructureUser/AddStructureUser',  addStructureDataBody, { headers: constants.headers })
                    .then(response => 
                    {
                        if (response.data != null)
                        {
                            if(response.data == 1)
                                window.showAlert(this.$t("res_Msgs_UserStructureUpdated"), 'success');
                            else if(response.data == 2)
                                window.showAlert(this.$t("res_Msgs_UserStructureAdded"), 'success');

                            this.resetStructureUser();
                            this.fetchNewStructure();
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(()=> window.hideLoading())
            },
            updateStructureUser()
            {
                if (this.structureData.structure == null || this.structureData.privacyLevel == null || !this.structureData.profession || !this.structureData.professionAr)
                {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                    return
                }

                var updateStructureDataBody = {
                    UserId:  this.userId,
                    StructureId: this.structureData.structure?.id ?? null,
                    Profession: this.structureData.profession,
                    ProfessionAr: this.structureData.professionAr,
                    IsStructureReceiver: this.structureData.isStructureReceiver != null ? this.structureData.isStructureReceiver : false,
                    IsDesignatedPerson: this.structureData.isDesignatedPerson != null ? this.structureData.isDesignatedPerson : false,
                    IsDefaultDesignatedPerson: this.structureData.isDefaultDesignatedPerson != null ? this.structureData.isDefaultDesignatedPerson : false,
                    PrivacyLevel: this.structureData.privacyLevel.id,
                    ContactRoleId: this.structureData.contactRole == null || this.structureData.contactRole.id == 0 ? null : this.structureData.contactRole.id, 
                    AllowSignSpecial: this.structureData.allowSignSpecial != null ? this.structureData.allowSignSpecial : false,
                    DontShowInTransfer: this.structureData.dontShowInTransfer != null ? this.structureData.dontShowInTransfer : false,
                    EditSigned: this.structureData.editSigned != null ? this.structureData.editSigned : false,
                    CanSearchInDepartment: this.structureData.canSearchInDepartment,
                    CanSearchInSubDepartment: this.structureData.canSearchInSubDepartment,
                    AllowESignature: this.structureData.allowESignature,
                    AllowUAEPASSSignature: this.structureData.allowUAEPASSSignature
                }

                window.showLoading();
                axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureUser',  updateStructureDataBody, { headers: constants.headers })
                    .then(response => 
                    {
                        if (response != null && response != undefined)
                        {
                            if (response.data =='success')
                            {
                                window.showAlert("res_Msgs_UpdateStructureSuccess", 'success');
                                this.showUpdateStructureUserBtn = false;
                                this.resetStructureUser();
                                this.fetchNewStructure()
                            }
                            else
                            {
                                window.showAlert(response.data, 'warning');
                            }
                        }
                    })
                    .catch(err => console.warn(err))     
                    .finally(()=> window.hideLoading())
            },
            close()
            {
                this.$emit('closeDialog')
            },
            CapitalizeFirstLetter(str)
            {
				return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options)
            {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            hasPermission(featureName) 
            {
                if (constants.userActions && constants.userActions.features) 
                {
                    return constants.userActions.features.some(f => f.name.toLowerCase() == featureName.toLowerCase());
                }
                return false;
            }
        },
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                        this.initForm()
                    else
                        this.resetStructureUser()
                }
            }
        },
        mounted() {
            this.initForm();
        }
    }
</script>


<style> 

.customTextarea{ 
    width: 100%;
    border-radius: 8px; 
    background-color: #eff2f5;
    outline: none;
    padding: 10px 19px 10px 15px;
    height: 46px;
    line-height: 1.7; 
    overflow: hidden !important; 
}

</style>